import React, { useContext, useEffect, useState } from "react";
import Form from "../../../components/form";
import cfe from "../../../services/cfe";
import ActionTable from "../../../components/table/ActionTable";
import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";
import { mergeParams } from "../../../helpers/helpers";
import AppContext from "../../../container/context";

let descricaoResposta = "";
let opcao = 0;

export default function Saque({ history, location }) {
  const [dados, setDados] = useState(
    mergeParams(
      {
        nomeInstituicao: "",
        exibirFinalizados: false,
      },
      location
    )
  );
  const [solicitacoesSaque, setSolicitacoesSaque] = useState([]);
  const [resposta, setResposta] = useState({});
  const [solicitacaoSaqueSelecionada, setSolicitacaoSaqueSelecionada] =
    useState({});
  const { notification } = useContext(AppContext);

  useEffect(() => {
    carregar();
  }, []);

  const carregar = (filtrosEnviar = dados) => {
    setDados(filtrosEnviar);

    cfe
      .get("admin/saques/gerenciamento", filtrosEnviar)
      .then((solicitacoesSaque) => {
        solicitacoesSaque.forEach((ss) => {
          ss.valor = `R$ ${(ss.valorSolicitado / 100).toFixed(2)}`;
          ss.dataHora = new Date(ss.solicitacao).toLocaleString("pt-BR");

          ss.situacao = ss.aprovacao
            ? `Aprovado (${new Date(ss.aprovacao).toLocaleString("pt-BR")})`
            : ss.recusa
            ? `Recusado (${new Date(ss.recusa).toLocaleString("pt-BR")})`
            : "Pendente";
        });

        setSolicitacoesSaque(solicitacoesSaque);
      })
      .catch((e) =>
        notification("error", "Erro ao listar os solicitações de saque")
      );
  };

  const fFiltros = {
    title: "Filtros",
    form: {
      nomeInstituicao: {
        label: "Nome",
        type: "text",
        value: dados.nome,
        space: 9,
      },
      exibirFinalizados: {
        label: "Exibir finalizados",
        type: "check",
        value: dados.nome,
        space: 3,
      },
    },

    submit: {
      label: "Buscar",
      action: carregar,
    },

    urlParams: true,
    history,
    location,
  };

  const tSolicitacoesSaque = {
    title: "Solicitações de saque",
    array: solicitacoesSaque,
    onLineClick: (solicitacaoSaqueSelecionada) =>
      setSolicitacaoSaqueSelecionada(solicitacaoSaqueSelecionada),
    columns: [
      {
        name: "instituicaoNomeFantasia",
        label: "Instituição",
      },
      {
        name: "valor",
        label: "Valor solicitado",
      },
      {
        name: "dataHora",
        label: "Data/hora",
      },
      {
        name: "situacao",
        label: "Situação",
      },
    ],
  };

  const fSolicitacaoSaque = {
    form: {
      nomeFantasia: {
        space: 6,
        type: "component",
        value: (
          <>
            <h4>Instituicao</h4>
            <p>{solicitacaoSaqueSelecionada.instituicaoNomeFantasia}</p>
          </>
        ),
      },
      dataHora: {
        space: 3,
        type: "component",
        value: (
          <>
            <h4>Data/hora</h4>
            <p>{solicitacaoSaqueSelecionada.dataHora}</p>
          </>
        ),
      },
      valorSolicitado: {
        space: 3,
        type: "component",
        value: (
          <>
            <h4>Valor solicitado</h4>
            <p>{solicitacaoSaqueSelecionada.valor}</p>
          </>
        ),
      },
      anotacaoSolicitante: {
        space: 6,
        type: "component",
        value: (
          <>
            <h4>Anotações/observações do solicitante</h4>
            <p>{solicitacaoSaqueSelecionada.anotacao}</p>
          </>
        ),
      },
      situacao: {
        space: 3,
        type: "component",
        value: (
          <>
            <h4>Situação</h4>
            <p>{solicitacaoSaqueSelecionada.situacao}</p>
          </>
        ),
      },
      valorAprovado: {
        space: 3,
        type: "component",
        value: (
          <>
            <h4>Valor aprovado</h4>
            <p>{solicitacaoSaqueSelecionada.valor}</p>
          </>
        ),
      },
    },

    close: {
      label: "Voltar",
      action: () => setSolicitacaoSaqueSelecionada({}),
    },
  };

  const responderSaque = (resposta) => {
    switch (resposta.resposta) {
      case 1:
        descricaoResposta = "o aceite";
        break;
      case 2:
        descricaoResposta = "a recusa";
        break;
      default:
        return notification("warning", "Selecione uma resposta.");
    }
    opcao = resposta.resposta;

    const valorAprovado = Math.floor(resposta.valor * 100);
    if (
      resposta.resposta === "1" &&
      valorAprovado > solicitacaoSaqueSelecionada.valorSolicitado
    )
      return notification(
        "warning",
        "O valor aprovado não pode ser maior que o selecionado."
      );

    const dadosResposta = {
      saqueId: solicitacaoSaqueSelecionada.id,
      aprovado: resposta.resposta === "1",
      anotacao: resposta.anotacao,
      valor: valorAprovado,
    };

    setResposta(dadosResposta);
  };

  const salvarSaque = () => {
    cfe
      .post("admin/saques/responder", resposta)
      .then(() => {
        notification("success", "Saque respondido com sucesso.");
        carregar();
        setResposta({});
        setSolicitacaoSaqueSelecionada({});
      })
      .catch((err) => {
        console.log(err);
        notification(
          "error",
          "Não foi possível responder o saque. Verifique os dados e tente novamente."
        );
      });
  };

  const fRespostaSaque = {
    title: "Responder solicitação",
    form: {
      resposta: {
        label: "Resposta",
        type: "select",
        options: [
          {
            value: 0,
            desc: "(Selecione)",
          },
          {
            value: 1,
            desc: "Aprovar saque",
          },
          {
            value: 2,
            desc: "Recusar saque",
          },
        ],
        space: 6,
        value: opcao,
      },
      valor: {
        label: "Valor aprovado",
        type: "number",
        space: 6,
        value: solicitacaoSaqueSelecionada.valorSolicitado
          ? (solicitacaoSaqueSelecionada.valorSolicitado / 100).toFixed(2)
          : 0,
      },
      anotacao: {
        label: "Anotações/observações para aceite ou recusa",
        type: "textarea",
        value: resposta.anotacao,
      },
    },

    submit: {
      label: "Finalizar",
      action: responderSaque,
    },
  };

  return (
    <div>
      {solicitacaoSaqueSelecionada.id ? (
        <>
          <Form formData={fSolicitacaoSaque} />
          <Form formData={fRespostaSaque} />

          <Dialog
            open={resposta.saqueId}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {`Confirma ${descricaoResposta} do saque? Não será possível
              desfazer.`}
            </DialogTitle>
            <DialogActions>
              <Button variant="contained" onClick={salvarSaque} autoFocus>
                Confirmar
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={() => setResposta({})}
              >
                Cancelar
              </Button>
            </DialogActions>
          </Dialog>
        </>
      ) : (
        <>
          <Form formData={fFiltros} />
          <ActionTable structure={tSolicitacoesSaque} />
        </>
      )}
    </div>
  );
}
